import React from 'react';
import classNames from 'clsx';

import { Image } from 'app/components/Image';
import { PaymentEnum } from 'app/shared/enums';

import { useStyles } from './WarrantyInfo.styles';
const WarrantyInfo = ({ center }: { center?: boolean }) => {
  const classes = useStyles();
  return (
    <div className={classes.warranty}>
      <div
        className={classNames(classes.warrantyInfo, {
          [classes.center]: center,
        })}
      >
        {PaymentEnum.WarrantyInfo}
      </div>
      <div className={classes.sslInfoContainer}>
        <Image
          src="./images/logos/ssl.png"
          srcSetWebp={'./images/logos/ssl.webp'}
          alt="ssl"
          className={classes.image}
          height={40}
          width={76}
        />
      </div>
    </div>
  );
};

export default WarrantyInfo;
